import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import { PremiumMenuIcon,PremiumCardIcon } from '../../../components/icons';
import Grid from '@material-ui/core/Grid';
import CalenderImg from '../../../assets/calendar.png';
import DiskImg from '../../../assets/desk-mobile.png';
import SupportImg from '../../../assets/support.png';
import VandiImg from '../../../assets/vandi.png';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  infoCard: {
    padding: "24px 18px",
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    borderRadius:16,
    boxShadow:'none',
    flexDirection:'column',
    minWidth:200,
    minHeight:152
  },
  infoCardTitle: {
    fontSize: 28,
    letterSpacing: 'normal',
    marginTop:24,
    color:'#fff'
  },
  infoCardSecondTitle: {
    color: '#0b1323',
    fontSize: 14,
    letterSpacing: 'normal',
    marginTop:4,
    textAlign:'center'
  },
  infoCardIcon: {
    fontSize: 64,
  }
}));
const PremimumInfoFeatures = (props) => {
  const {subscriptionStatus,price} = props;
  const classes = useStyles();
  let features = [
    {
      img:CalenderImg,
      bg:'#efeeff',
      text:<>Download all Reports<br />(PDF,XLS)</>
    },
    {
      img:DiskImg,
      bg:'#e3f2fb',
      text:<>Mobile App <br />Integration</>
    },
    {
      img:VandiImg,
      bg:'#ecfdef',
      text:<>Create unlimited Trips,<br /> Parties and more</>
    },
    {
      img:SupportImg,
      bg:'#fef7eb',
      text:<>Support for upto<br />10 users</>
    }
  ]
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={3}
    >
      {features && features.map((value)=>{
        return <Grid item xs>
        <Paper className={classes.infoCard} style={{backgroundColor:value&&value.bg?value.bg:'#fff'}}>
            {value && value.img&&<img alt="" src={value.img} width={60} height={60} />}
            <Typography className={classes.infoCardSecondTitle} >{value.text}</Typography>
        </Paper>
      </Grid>
      })}
    </Grid>
  );
}
export default PremimumInfoFeatures;